/** UI copy for the KYC form and the verification landing page. Merged into locale messages. */
const form = {
  ru: {
    backToType: 'Назад к выбору типа',
    draftRestored: 'Черновик анкеты восстановлен. Можно продолжить с того же места.',
    consentTitle: 'Согласие на обработку данных',
    individualLead: 'Идентификация физического лица',
    entrepreneurLead: 'Идентификация индивидуального предпринимателя',
    consentBody: 'Я подтверждаю достоверность представленной информации и соглашаюсь на {link}, передачу третьим лицом в соответствие с законодательством и международными договорами, трансграничную передачу персональных данных, находящимся под юрисдикцией других государств.',
    consentLink: 'сбор и обработку персональных данных',
    consentCheck: 'Подтверждаю согласие на обработку персональных данных',
    consentRequired: 'Подтвердите согласие на обработку персональных данных',
    recheckCheck: 'Даю согласие на регулярную перепроверку персональных данных и соглашаюсь их ежегодно обновлять',
    recheckRequired: 'Подтвердите согласие на перепроверку и ежегодное обновление персональных данных',
    personalTitle: 'Персональные данные',
    personalLead: 'Введите данные точно как в документе, удостоверяющем личность',
    lastName: 'Фамилия',
    lastNamePh: 'Введите вашу фамилию',
    firstName: 'Имя',
    firstNamePh: 'Введите ваше имя',
    middleName: 'Отчество',
    ifAny: 'При наличии',
    ifPresent: 'Если имеется',
    ifInDocument: 'При наличии в документе',
    birthDate: 'Дата рождения',
    gender: 'Пол',
    genderUnset: 'Не указан',
    genderUnsetNeut: 'Не указано',
    male: 'Мужской',
    female: 'Женский',
    citizenship: 'Гражданство',
    livesInKr: 'Проживаете на территории Кыргызской Республики?',
    livesInKrRequired: 'Укажите, проживаете ли вы на территории КР',
    placeOfBirth: 'Место рождения',
    nationality: 'Национальность',
    maritalStatus: 'Семейное положение',
    choose: 'Выберите',
    marital: {
      single: 'Холост / не замужем',
      married: 'Женат / замужем',
      divorced: 'В разводе',
      widowed: 'Вдовец / вдова',
    },
    alphabetKr: 'Для граждан КР персональные данные вводятся на кириллице.',
    alphabetForeign: 'Для иностранных граждан персональные данные вводятся на латинице (согласно документу).',
    alphabetKz: 'Для граждан Казахстана используйте единый алфавит (кириллица или латиница согласно документу).',
    documentTitle: 'Документ и контакты',
    documentLead: 'Реквизиты документа, контакты и адреса',
    identityDoc: 'Документ, удостоверяющий личность',
    docType: 'Тип документа',
    idCard: 'ID-карта',
    passport: 'Паспорт',
    foreignPassport: 'Заграничный паспорт',
    otherDoc: 'Другой',
    series: 'Серия',
    seriesPh: 'Серия документа',
    seriesHint: 'На карте: ID или AN',
    seriesId: 'ID — биометрическая (2017, 2024)',
    seriesAn: 'AN — образца 2004',
    seriesRequired: 'Выберите серию: ID или AN',
    idNumber: 'Номер ID-карты',
    passportNumber: 'Номер паспорта',
    idNumberPh: 'Например: 1234567',
    passportNumberPh: 'Номер как в паспорте',
    issueDate: 'Дата выдачи',
    expiryDate: 'Дата окончания срока действия',
    idIssuer: 'Кем выдана ID-карта',
    passportIssuer: 'Кем выдан паспорт',
    idIssuerPh: 'ГРС при ПКР',
    passportIssuerPh: 'Орган, выдавший документ',
    departmentCode: 'Код подразделения',
    departmentHint: 'Латинские буквы, пробел, цифры',
    departmentRequired: 'Укажите код подразделения',
    departmentFormat: 'Формат: латинские буквы, пробел, цифры (например, MKK 216021)',
    pinPh: '14 цифр',
    taxIfAny: 'Налоговый номер (при наличии)',
    inn: 'ИНН',
    contacts: 'Контакты',
    contactsLocked: 'Телефон и почта взяты из регистрации и здесь не меняются.',
    mobile: 'Мобильный телефон',
    email: 'Электронная почта',
    homePhone: 'Домашний телефон',
    workPhone: 'Рабочий телефон',
    fax: 'Факс',
    registrationAddress: 'Адрес места регистрации',
    addressHint: 'Страна, город или населённый пункт, улица и дом обязательны. Весь адрес — на одном языке.',
    addressRussianHint: 'Страна, город или населённый пункт, улица и дом обязательны. Адрес указывается только на русском языке.',
    addressEnglishHint: 'Страна, город или населённый пункт, улица и дом обязательны. Адрес указывается только на английском языке.',
    addressOneLanguage: 'Весь адрес — на одном языке.',
    addressRussianOnly: 'Адрес указывается только на русском языке.',
    addressEnglishOnly: 'Адрес указывается только на английском языке.',
    actualAddress: 'Адрес фактического проживания или пребывания',
    sameAsRegistration: 'Совпадает с адресом регистрации',
    profileTitle: 'Деловой профиль',
    profileLead: 'Сведения о цели отношений, публичном статусе и бенефициарном владельце',
    purpose: 'Цель и предполагаемый характер деловых отношений',
    purposePh: 'Например: открытие электронного кошелька для личных платежей и переводов',
    pepTitle: 'Публичное должностное лицо (ПДЛ)',
    pepQuestion: 'Являетесь ли вы публичным должностным лицом?',
    pepRequired: 'Укажите, являетесь ли вы ПДЛ',
    pepPosition: 'Занимаемая должность',
    pepPositionPh: 'Должность и орган',
    beneficialTitle: 'Бенефициарный владелец',
    beneficialQuestion: 'Действуете ли вы в интересах другого лица (бенефициарного владельца)?',
    present: 'Имеется',
    absent: 'Не имеется',
    beneficialRequired: 'Укажите наличие бенефициарного владельца',
    beneficialName: 'ФИО бенефициарного владельца',
    beneficialNamePh: 'Фамилия Имя Отчество',
    beneficialNameRequired: 'Укажите ФИО бенефициарного владельца',
    status: 'Статус',
    resident: 'Резидент',
    nonResident: 'Нерезидент',
    docNumber: 'Номер документа',
    numberPh: 'Номер',
    fundsTitle: 'Полномочия по распоряжению средствами',
    fundsLabel: 'Документы, подтверждающие полномочия по распоряжению денежными средствами или имуществом (заполняется в случае, если средства принадлежат третьим лицам и операции проводятся от их имени)',
    fundsPh: 'Доверенность, карточка образцов подписей и т.п. Если действуете только от своего имени — оставьте пустым',
    fundsScan: 'Скан документа о полномочиях',
    fundsScanHint: 'Документ загружается в случае заполнения предыдущего пункта «Полномочия по распоряжению средствами»',
    fundsScanRequired: 'Загрузите скан документа о полномочиях',
    fundsTextRequired: 'Заполните пункт «Полномочия по распоряжению средствами»',
    optional: 'Необязательно',
    recommended: 'Рекомендуется',
    required: 'Обязательно',
    chooseFile: 'Выберите файл',
    ipTitle: 'Сведения об ИП',
    ipLead: 'Данные о регистрации индивидуального предпринимателя',
    ipStep: 'Сведения ИП',
    registration: 'Регистрация',
    registrationDate: 'Дата регистрации',
    registrationNumber: 'Регистрационный номер',
    registeringAuthority: 'Наименование регистрирующего органа',
    registeringAuthorityPh: 'Орган регистрации',
    registrationPlace: 'Место регистрации',
    patentTitle: 'Патент / лицензия',
    patentKind: 'Вид патента или лицензии',
    kindPh: 'Вид',
    patentNumber: 'Номер патента или лицензии',
    validity: 'Срок действия',
    issuedBy: 'Кем выдан',
    issuedByPh: 'Орган, выдавший документ',
    activities: 'Перечень видов деятельности',
    activitiesPh: 'Виды деятельности',
    ipDocs: 'Документы ИП',
    ipCertificate: 'Свидетельство о регистрации ИП',
    identificationTitle: 'Идентификация личности',
    identificationLead: 'Загрузите фото документа в соответствии с требованиями НБКР',
    uploadPhotos: 'Загрузите фото для верификации',
    photosKept: 'Ранее загруженные фото сохранены. Прикрепите новые, только если их нужно заменить.',
    frontSide: 'Лицевая сторона документа',
    idFrontLabel: 'Лицевая сторона ID-карты',
    passportFrontLabel: 'Страница паспорта с фото',
    idFrontHint: 'Сфотографируйте карту в рамке или прикрепите PDF/PNG/JPG. Фото, ФИО и номер должны читаться',
    passportFrontHint: 'Сфотографируйте страницу с фото и данными или прикрепите PDF/PNG/JPG',
    frontRequired: 'Загрузите фото лицевой стороны',
    backSide: 'Обратная сторона документа',
    idBackLabel: 'Обратная сторона ID-карты',
    passportBackLabel: 'Оборот паспорта',
    idBackHint: 'Три нижние строки с символами «<» должны быть внутри рамки: по ним данные сверяются автоматически',
    passportBackHint: 'Сфотографируйте страницу с машиночитаемой зоной или второй разворот, если он есть',
    backRequired: 'Загрузите фото обратной стороны',
    selfie: 'Селфи с паспортом',
    selfieHint: 'Сфотографируйтесь в приложении: лицо в овале, паспорт в рамке. Можно прикрепить готовое фото',
    selfieRequired: 'Сфотографируйте селфи с паспортом',
    residenceDocTitle: 'Документ о праве на пребывание (проживание) в КР',
    residenceDocName: 'Наименование документа',
    residencePermit: 'Вид на жительство',
    temporaryPermit: 'Разрешение на временное проживание',
    visa: 'Виза',
    residenceKindRequired: 'Выберите вид документа',
    validFrom: 'Дата начала срока действия',
    periodInvalid: 'Дата окончания раньше даты начала',
    docNumberRequired: 'Укажите номер документа',
    confirmTitle: 'Подтверждение данных',
    confirmLead: 'Проверьте введённые данные перед отправкой',
    fullName: 'ФИО',
    livesInKrShort: 'Проживание в КР',
    registrationAddressShort: 'Адрес регистрации',
    residenceAddressShort: 'Адрес проживания',
    purposeShort: 'Цель отношений',
    pepShort: 'ПДЛ',
    stayRight: 'Право на пребывание',
    ipInfo: 'Сведения ИП',
    regNumberShort: 'Рег. номер',
    activitiesShort: 'Виды деятельности',
    identificationNbkr: 'Идентификация (НБКР)',
    photoFront: 'Фото лицевой стороны',
    photoBack: 'Фото обратной стороны',
    nextStep: 'Следующий шаг',
    submitting: 'Отправка...',
    submit: 'Отправить заявку',
    termsTitle: 'Условия обработки данных',
    termsP1: 'Настоящим я даю согласие на обработку моих персональных данных в соответствии с требованиями законодательства Кыргызской Республики.',
    termsP2: 'Согласие распространяется на обработку следующих персональных данных:',
    termsPersonal: 'Персональные данные физического лица',
    termsContacts: 'Контактная информация',
    termsDocs: 'Документы и справки',
    termsP3: 'Обработка данных осуществляется в целях проведения идентификации и предоставления платёжных услуг.',
    goDashboard: 'Перейти в личный кабинет',
    retry: 'Попробовать снова',
    steps: {
      consent: 'Согласие',
      personal: 'Данные',
      document: 'Документ',
      profile: 'Профиль',
      identification: 'Идентификация',
      confirm: 'Подтверждение',
      face: 'Лицо',
    },
    errors: {
      required: 'Это поле обязательно для заполнения',
      minLength: 'Минимальная длина: {min} символов',
      notFuture: 'Дата не может быть в будущем',
      minAge: 'Минимальный возраст: {years} лет',
      pinDigits: 'ПИН должен содержать 14 цифр',
      innDigits: 'ИНН должен содержать 14 цифр',
      activeTitle: 'Заявка уже отправлена',
      activeMessage: 'У вас уже есть активная заявка на идентификацию. Дождитесь её рассмотрения или проверьте статус в личном кабинете.',
      emailTitle: 'Email не подтверждён',
      emailMessage: 'Для отправки заявки необходимо подтвердить ваш email адрес. Проверьте почту и перейдите по ссылке из письма.',
      submitTitle: 'Ошибка отправки',
      submitMessage: 'Произошла ошибка при отправке заявки. Попробуйте позже.',
      storedPhotoFailed: 'Не удалось приложить ранее загруженное фото. Проверьте соединение и попробуйте ещё раз.',
    },
    yesWithDetail: 'Да ({detail})',
  },
  en: {
    backToType: 'Back to type selection',
    draftRestored: 'Your draft was restored. You can continue where you left off.',
    consentTitle: 'Consent to data processing',
    individualLead: 'Identification of an individual',
    entrepreneurLead: 'Identification of a sole proprietor',
    consentBody: 'I confirm that the information provided is accurate and I consent to the {link}, its transfer to third parties in accordance with the law and international treaties, and the cross-border transfer of personal data to parties under the jurisdiction of other states.',
    consentLink: 'collection and processing of personal data',
    consentCheck: 'I consent to the processing of personal data',
    consentRequired: 'Confirm your consent to personal data processing',
    recheckCheck: 'I consent to regular re-checks of personal data and agree to update it annually',
    recheckRequired: 'Confirm your consent to re-checks and the annual update of personal data',
    personalTitle: 'Personal details',
    personalLead: 'Enter the details exactly as they appear in your identity document',
    lastName: 'Last name',
    lastNamePh: 'Enter your last name',
    firstName: 'First name',
    firstNamePh: 'Enter your first name',
    middleName: 'Middle name',
    ifAny: 'If any',
    ifPresent: 'If available',
    ifInDocument: 'If shown in the document',
    birthDate: 'Date of birth',
    gender: 'Sex',
    genderUnset: 'Not specified',
    genderUnsetNeut: 'Not specified',
    male: 'Male',
    female: 'Female',
    citizenship: 'Citizenship',
    livesInKr: 'Do you reside in the Kyrgyz Republic?',
    livesInKrRequired: 'State whether you reside in the Kyrgyz Republic',
    placeOfBirth: 'Place of birth',
    nationality: 'Nationality',
    maritalStatus: 'Marital status',
    choose: 'Select',
    marital: {
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
    },
    alphabetKr: 'Citizens of the Kyrgyz Republic must enter personal details in Cyrillic.',
    alphabetForeign: 'Foreign citizens must enter personal details in Latin script, as in the document.',
    alphabetKz: 'Citizens of Kazakhstan must use one alphabet (Cyrillic or Latin, as in the document).',
    documentTitle: 'Document and contacts',
    documentLead: 'Document details, contacts and addresses',
    identityDoc: 'Identity document',
    docType: 'Document type',
    idCard: 'ID card',
    passport: 'Passport',
    foreignPassport: 'Foreign passport',
    otherDoc: 'Other',
    series: 'Series',
    seriesPh: 'Document series',
    seriesHint: 'On the card: ID or AN',
    seriesId: 'ID — biometric (2017, 2024)',
    seriesAn: 'AN — 2004 specimen',
    seriesRequired: 'Select a series: ID or AN',
    idNumber: 'ID card number',
    passportNumber: 'Passport number',
    idNumberPh: 'For example: 1234567',
    passportNumberPh: 'Number as in the passport',
    issueDate: 'Date of issue',
    expiryDate: 'Expiry date',
    idIssuer: 'ID card issued by',
    passportIssuer: 'Passport issued by',
    idIssuerPh: 'SRS under the PKR',
    passportIssuerPh: 'Issuing authority',
    departmentCode: 'Department code',
    departmentHint: 'Latin letters, a space, digits',
    departmentRequired: 'Enter the department code',
    departmentFormat: 'Format: Latin letters, a space, digits (for example, MKK 216021)',
    pinPh: '14 digits',
    taxIfAny: 'Tax number (if any)',
    inn: 'TIN',
    contacts: 'Contacts',
    contactsLocked: 'Phone and email come from registration and cannot be changed here.',
    mobile: 'Mobile phone',
    email: 'Email',
    homePhone: 'Home phone',
    workPhone: 'Work phone',
    fax: 'Fax',
    registrationAddress: 'Registered address',
    addressHint: 'Country, city or locality, street and house number are required. The whole address must be in one language.',
    addressRussianHint: 'Country, city or locality, street and house number are required. The address must be in Russian.',
    addressEnglishHint: 'Country, city or locality, street and house number are required. The address must be in English.',
    addressOneLanguage: 'The whole address must be in one language.',
    addressRussianOnly: 'The address must be in Russian.',
    addressEnglishOnly: 'The address must be in English.',
    actualAddress: 'Actual residence or stay address',
    sameAsRegistration: 'Same as the registered address',
    profileTitle: 'Business profile',
    profileLead: 'Purpose of the relationship, public status and beneficial owner',
    purpose: 'Purpose and expected nature of the business relationship',
    purposePh: 'For example: opening an e-wallet for personal payments and transfers',
    pepTitle: 'Politically exposed person (PEP)',
    pepQuestion: 'Are you a politically exposed person?',
    pepRequired: 'State whether you are a PEP',
    pepPosition: 'Position held',
    pepPositionPh: 'Position and authority',
    beneficialTitle: 'Beneficial owner',
    beneficialQuestion: 'Are you acting in the interest of another person (a beneficial owner)?',
    present: 'Yes',
    absent: 'No',
    beneficialRequired: 'State whether there is a beneficial owner',
    beneficialName: 'Beneficial owner’s full name',
    beneficialNamePh: 'Last name First name Middle name',
    beneficialNameRequired: 'Enter the beneficial owner’s full name',
    status: 'Status',
    resident: 'Resident',
    nonResident: 'Non-resident',
    docNumber: 'Document number',
    numberPh: 'Number',
    fundsTitle: 'Authority to dispose of funds',
    fundsLabel: 'Documents confirming authority to dispose of funds or property (complete if the funds belong to third parties and operations are made on their behalf)',
    fundsPh: 'Power of attorney, signature card, and so on. Leave empty if you act only on your own behalf',
    fundsScan: 'Scan of the authority document',
    fundsScanHint: 'Upload the document if you filled in the previous item “Authority to dispose of funds”',
    fundsScanRequired: 'Upload the scan of the authority document',
    fundsTextRequired: 'Fill in “Authority to dispose of funds”',
    optional: 'Optional',
    recommended: 'Recommended',
    required: 'Required',
    chooseFile: 'Choose a file',
    ipTitle: 'Sole proprietor details',
    ipLead: 'Registration details of the sole proprietor',
    ipStep: 'Sole proprietor',
    registration: 'Registration',
    registrationDate: 'Registration date',
    registrationNumber: 'Registration number',
    registeringAuthority: 'Name of the registering authority',
    registeringAuthorityPh: 'Registering authority',
    registrationPlace: 'Place of registration',
    patentTitle: 'Patent / license',
    patentKind: 'Type of patent or license',
    kindPh: 'Type',
    patentNumber: 'Patent or license number',
    validity: 'Validity period',
    issuedBy: 'Issued by',
    issuedByPh: 'Issuing authority',
    activities: 'List of activities',
    activitiesPh: 'Activities',
    ipDocs: 'Sole proprietor documents',
    ipCertificate: 'Sole proprietor registration certificate',
    identificationTitle: 'Identity verification',
    identificationLead: 'Upload a photo of the document as required by the NBKR',
    uploadPhotos: 'Upload photos for verification',
    photosKept: 'Previously uploaded photos are kept. Attach new ones only if they need to be replaced.',
    frontSide: 'Front of the document',
    idFrontLabel: 'Front of the ID card',
    passportFrontLabel: 'Passport page with the photo',
    idFrontHint: 'Photograph the card inside the frame, or attach a PDF/PNG/JPG. The photo, name and number must be readable',
    passportFrontHint: 'Photograph the page with the photo and details, or attach a PDF/PNG/JPG',
    frontRequired: 'Upload a photo of the front side',
    backSide: 'Back of the document',
    idBackLabel: 'Back of the ID card',
    passportBackLabel: 'Passport reverse',
    idBackHint: 'The three bottom lines with «<» symbols must stay inside the frame: they are checked automatically',
    passportBackHint: 'Photograph the page with the machine-readable zone, or the second spread if there is one',
    backRequired: 'Upload a photo of the back side',
    selfie: 'Selfie with passport',
    selfieHint: 'Take the photo in the app: face in the oval, passport in the frame. You can also attach a ready photo',
    selfieRequired: 'Take a selfie with your passport',
    residenceDocTitle: 'Document confirming the right to stay (reside) in the Kyrgyz Republic',
    residenceDocName: 'Document name',
    residencePermit: 'Residence permit',
    temporaryPermit: 'Temporary residence permit',
    visa: 'Visa',
    residenceKindRequired: 'Select the document type',
    validFrom: 'Valid from',
    periodInvalid: 'The end date is earlier than the start date',
    docNumberRequired: 'Enter the document number',
    confirmTitle: 'Confirm your details',
    confirmLead: 'Check the details before submitting',
    fullName: 'Full name',
    livesInKrShort: 'Residence in the KR',
    registrationAddressShort: 'Registered address',
    residenceAddressShort: 'Residence address',
    purposeShort: 'Purpose of the relationship',
    pepShort: 'PEP',
    stayRight: 'Right to stay',
    ipInfo: 'Sole proprietor details',
    regNumberShort: 'Reg. number',
    activitiesShort: 'Activities',
    identificationNbkr: 'Identification (NBKR)',
    photoFront: 'Photo of the front side',
    photoBack: 'Photo of the back side',
    nextStep: 'Next step',
    submitting: 'Submitting...',
    submit: 'Submit application',
    termsTitle: 'Data processing terms',
    termsP1: 'I hereby consent to the processing of my personal data in accordance with the laws of the Kyrgyz Republic.',
    termsP2: 'The consent covers processing of the following personal data:',
    termsPersonal: 'Personal data of an individual',
    termsContacts: 'Contact information',
    termsDocs: 'Documents and certificates',
    termsP3: 'Data is processed for identification and for providing payment services.',
    goDashboard: 'Go to dashboard',
    retry: 'Try again',
    steps: {
      consent: 'Consent',
      personal: 'Details',
      document: 'Document',
      profile: 'Profile',
      identification: 'Identification',
      confirm: 'Confirm',
      face: 'Face',
    },
    errors: {
      required: 'This field is required',
      minLength: 'Minimum length: {min} characters',
      notFuture: 'The date cannot be in the future',
      minAge: 'Minimum age: {years}',
      pinDigits: 'The PIN must contain 14 digits',
      innDigits: 'The TIN must contain 14 digits',
      activeTitle: 'Application already submitted',
      activeMessage: 'You already have an active identification application. Wait for it to be reviewed, or check the status in your dashboard.',
      emailTitle: 'Email not confirmed',
      emailMessage: 'Confirm your email address before submitting. Check your inbox and open the link in the message.',
      submitTitle: 'Submission error',
      submitMessage: 'The application could not be submitted. Please try again later.',
      storedPhotoFailed: 'Could not attach a previously uploaded photo. Check your connection and try again.',
    },
    yesWithDetail: 'Yes ({detail})',
  },
  ky: {
    backToType: 'Түр тандоого кайтуу',
    draftRestored: 'Анкетанын черновиги калыбына келтирилди. Ошол жерден улантсаңыз болот.',
    consentTitle: 'Маалыматты иштетүүгө макулдук',
    individualLead: 'Жеке адамды идентификациялоо',
    entrepreneurLead: 'Жеке ишкерди идентификациялоо',
    consentBody: 'Берилген маалыматтын тууралыгын ырастайм жана {link}, мыйзамга жана эл аралык келишимдерге ылайык үчүнчү жактарга берүүгө, ошондой эле башка мамлекеттердин юрисдикциясындагы жактарга чек ара аркылуу берүүгө макулмун.',
    consentLink: 'жеке маалыматтарды чогултууга жана иштетүүгө',
    consentCheck: 'Жеке маалыматтарды иштетүүгө макулдук берем',
    consentRequired: 'Жеке маалыматтарды иштетүүгө макулдукту ырастаңыз',
    recheckCheck: 'Жеке маалыматтарды үзгүлтүксүз кайра текшерүүгө макулмун жана аларды жыл сайын жаңыртууга макулмун',
    recheckRequired: 'Кайра текшерүүгө жана жыл сайын жаңыртууга макулдукту ырастаңыз',
    personalTitle: 'Жеке маалыматтар',
    personalLead: 'Маалыматты инсандыкты ырастаган документтегидей так киргизиңиз',
    lastName: 'Фамилия',
    lastNamePh: 'Фамилияңызды киргизиңиз',
    firstName: 'Аты',
    firstNamePh: 'Атыңызды киргизиңиз',
    middleName: 'Атасынын аты',
    ifAny: 'Бар болсо',
    ifPresent: 'Бар болсо',
    ifInDocument: 'Документте бар болсо',
    birthDate: 'Туулган күнү',
    gender: 'Жынысы',
    genderUnset: 'Көрсөтүлгөн эмес',
    genderUnsetNeut: 'Көрсөтүлгөн эмес',
    male: 'Эркек',
    female: 'Аял',
    citizenship: 'Жарандыгы',
    livesInKr: 'Кыргыз Республикасынын аймагында жашайсызбы?',
    livesInKrRequired: 'КР аймагында жашай турганыңызды көрсөтүңүз',
    placeOfBirth: 'Туулган жери',
    nationality: 'Улуту',
    maritalStatus: 'Үй-бүлөлүк абалы',
    choose: 'Тандаңыз',
    marital: {
      single: 'Бойдок / турмушка чыга элек',
      married: 'Үйлөнгөн / турмушка чыккан',
      divorced: 'Ажырашкан',
      widowed: 'Жесир',
    },
    alphabetKr: 'КР жарандары жеке маалыматты кириллица менен киргизет.',
    alphabetForeign: 'Чет өлкөлүк жарандар жеке маалыматты латиница менен, документке ылайык киргизет.',
    alphabetKz: 'Казакстандын жарандары бир алфавитти колдонуңуз (документке ылайык кириллица же латиница).',
    documentTitle: 'Документ жана байланыш',
    documentLead: 'Документтин реквизиттери, байланыш жана даректер',
    identityDoc: 'Инсандыкты ырастаган документ',
    docType: 'Документтин түрү',
    idCard: 'ID-карта',
    passport: 'Паспорт',
    foreignPassport: 'Чет өлкөлүк паспорт',
    otherDoc: 'Башка',
    series: 'Сериясы',
    seriesPh: 'Документтин сериясы',
    seriesHint: 'Картада: ID же AN',
    seriesId: 'ID — биометриялык (2017, 2024)',
    seriesAn: 'AN — 2004-жылкы үлгү',
    seriesRequired: 'Серияны тандаңыз: ID же AN',
    idNumber: 'ID-картанын номери',
    passportNumber: 'Паспорттун номери',
    idNumberPh: 'Мисалы: 1234567',
    passportNumberPh: 'Паспорттогу номер',
    issueDate: 'Берилген күнү',
    expiryDate: 'Жарактуулук мөөнөтүнүн аягы',
    idIssuer: 'ID-картаны берген орган',
    passportIssuer: 'Паспортту берген орган',
    idIssuerPh: 'КР ПК алдындагы МКК',
    passportIssuerPh: 'Документти берген орган',
    departmentCode: 'Бөлүмдүн коду',
    departmentHint: 'Латын тамгалары, боштук, сандар',
    departmentRequired: 'Бөлүмдүн кодун көрсөтүңүз',
    departmentFormat: 'Формат: латын тамгалары, боштук, сандар (мисалы, MKK 216021)',
    pinPh: '14 сан',
    taxIfAny: 'Салык номери (бар болсо)',
    inn: 'ИНН',
    contacts: 'Байланыш',
    contactsLocked: 'Телефон жана почта каттоодон алынган, бул жерде өзгөртүлбөйт.',
    mobile: 'Мобилдик телефон',
    email: 'Электрондук почта',
    homePhone: 'Үй телефону',
    workPhone: 'Жумуш телефону',
    fax: 'Факс',
    registrationAddress: 'Каттоо дареги',
    addressHint: 'Өлкө, шаар же калктуу пункт, көчө жана үй милдеттүү. Даректин баары бир тилде болушу керек.',
    addressRussianHint: 'Өлкө, шаар же калктуу пункт, көчө жана үй милдеттүү. Дарек орус тилинде гана жазылат.',
    addressEnglishHint: 'Өлкө, шаар же калктуу пункт, көчө жана үй милдеттүү. Дарек англис тилинде гана жазылат.',
    addressOneLanguage: 'Даректин баары бир тилде болушу керек.',
    addressRussianOnly: 'Дарек орус тилинде гана жазылат.',
    addressEnglishOnly: 'Дарек англис тилинде гана жазылат.',
    actualAddress: 'Иш жүзүндө жашаган же болгон дарек',
    sameAsRegistration: 'Каттоо дареги менен дал келет',
    profileTitle: 'Ишкердик профили',
    profileLead: 'Мамиленин максаты, коомдук статус жана бенефициардык ээ жөнүндө маалымат',
    purpose: 'Ишкердик мамилелердин максаты жана болжолдуу мүнөзү',
    purposePh: 'Мисалы: жеке төлөмдөр жана которуулар үчүн электрондук капчык ачуу',
    pepTitle: 'Коомдук кызмат адамы (ПДЛ)',
    pepQuestion: 'Сиз коомдук кызмат адамысызбы?',
    pepRequired: 'ПДЛ экениңизди көрсөтүңүз',
    pepPosition: 'Ээлеген кызматы',
    pepPositionPh: 'Кызмат жана орган',
    beneficialTitle: 'Бенефициардык ээ',
    beneficialQuestion: 'Сиз башка адамдын (бенефициардык ээнин) кызыкчылыгында иштейсизби?',
    present: 'Бар',
    absent: 'Жок',
    beneficialRequired: 'Бенефициардык ээнин бар экенин көрсөтүңүз',
    beneficialName: 'Бенефициардык ээнин ФАА',
    beneficialNamePh: 'Фамилия Аты Атасынын аты',
    beneficialNameRequired: 'Бенефициардык ээнин ФААсын көрсөтүңүз',
    status: 'Статусу',
    resident: 'Резидент',
    nonResident: 'Резидент эмес',
    docNumber: 'Документтин номери',
    numberPh: 'Номер',
    fundsTitle: 'Каражатты тескөө ыйгарым укугу',
    fundsLabel: 'Акча каражаттарын же мүлктү тескөө ыйгарым укугун ырастаган документтер (каражат үчүнчү жактарга таандык болсо жана операциялар алардын атынан жүргүзүлсө толтурулат)',
    fundsPh: 'Ишеним кат, кол тамгалардын үлгүсү ж.б. Өз атыңыздан гана иштесеңиз — бош калтырыңыз',
    fundsScan: 'Ыйгарым укук документинин сканы',
    fundsScanHint: 'Документ мурунку «Каражатты тескөө ыйгарым укугу» пункту толтурулганда жүктөлөт',
    fundsScanRequired: 'Ыйгарым укук документинин сканын жүктөңүз',
    fundsTextRequired: '«Каражатты тескөө ыйгарым укугу» пунктун толтуруңуз',
    optional: 'Милдеттүү эмес',
    recommended: 'Сунушталат',
    required: 'Милдеттүү',
    chooseFile: 'Файл тандаңыз',
    ipTitle: 'ЖИ жөнүндө маалымат',
    ipLead: 'Жеке ишкердин каттоо маалыматы',
    ipStep: 'ЖИ маалыматы',
    registration: 'Каттоо',
    registrationDate: 'Каттоо күнү',
    registrationNumber: 'Каттоо номери',
    registeringAuthority: 'Каттоочу органдын аталышы',
    registeringAuthorityPh: 'Каттоо органы',
    registrationPlace: 'Каттоо жери',
    patentTitle: 'Патент / лицензия',
    patentKind: 'Патенттин же лицензиянын түрү',
    kindPh: 'Түрү',
    patentNumber: 'Патенттин же лицензиянын номери',
    validity: 'Жарактуулук мөөнөтү',
    issuedBy: 'Ким берген',
    issuedByPh: 'Документти берген орган',
    activities: 'Иштин түрлөрүнүн тизмеси',
    activitiesPh: 'Иштин түрлөрү',
    ipDocs: 'ЖИ документтери',
    ipCertificate: 'ЖИ каттоо күбөлүгү',
    identificationTitle: 'Инсанды идентификациялоо',
    identificationLead: 'Улуттук банктын талаптарына ылайык документтин сүрөтүн жүктөңүз',
    uploadPhotos: 'Верификация үчүн сүрөт жүктөңүз',
    photosKept: 'Мурда жүктөлгөн сүрөттөр сакталган. Аларды алмаштыруу керек болсо гана жаңысын тиркеңиз.',
    frontSide: 'Документтин алдыңкы бети',
    idFrontLabel: 'ID-картанын алдыңкы бети',
    passportFrontLabel: 'Сүрөтү бар паспорт барагы',
    idFrontHint: 'Картаны алкакка түшүрүңүз же PDF/PNG/JPG тиркеңиз. Сүрөт, ФАА жана номер окулушу керек',
    passportFrontHint: 'Сүрөтү жана маалыматы бар баракты сүрөткө тартыңыз же PDF/PNG/JPG тиркеңиз',
    frontRequired: 'Алдыңкы беттин сүрөтүн жүктөңүз',
    backSide: 'Документтин арткы бети',
    idBackLabel: 'ID-картанын арткы бети',
    passportBackLabel: 'Паспорттун арткы бети',
    idBackHint: '«<» белгилери бар төмөнкү үч сап алкактын ичинде болушу керек: маалымат ошолор боюнча автоматтык салыштырылат',
    passportBackHint: 'Машина окуй турган аймагы бар баракты же экинчи жайылманы, бар болсо, сүрөткө тартыңыз',
    backRequired: 'Арткы беттин сүрөтүн жүктөңүз',
    selfie: 'Паспорт менен селфи',
    selfieHint: 'Тиркемеде сүрөткө түшүңүз: жүз сүйрүдө, паспорт алкакта. Даяр сүрөттү да тиркесе болот',
    selfieRequired: 'Паспорт менен селфи тартыңыз',
    residenceDocTitle: 'КРде болууга (жашоого) укук берген документ',
    residenceDocName: 'Документтин аталышы',
    residencePermit: 'Жашоого уруксат',
    temporaryPermit: 'Убактылуу жашоого уруксат',
    visa: 'Виза',
    residenceKindRequired: 'Документтин түрүн тандаңыз',
    validFrom: 'Жарактуулуктун башталышы',
    periodInvalid: 'Аяктоо күнү башталышынан эрте',
    docNumberRequired: 'Документтин номерин көрсөтүңүз',
    confirmTitle: 'Маалыматты ырастоо',
    confirmLead: 'Жөнөтүүдөн мурун киргизилген маалыматты текшериңиз',
    fullName: 'ФАА',
    livesInKrShort: 'КРде жашоо',
    registrationAddressShort: 'Каттоо дареги',
    residenceAddressShort: 'Жашаган дареги',
    purposeShort: 'Мамиленин максаты',
    pepShort: 'ПДЛ',
    stayRight: 'Болууга укук',
    ipInfo: 'ЖИ маалыматы',
    regNumberShort: 'Каттоо номери',
    activitiesShort: 'Иштин түрлөрү',
    identificationNbkr: 'Идентификация (УБКР)',
    photoFront: 'Алдыңкы беттин сүрөтү',
    photoBack: 'Арткы беттин сүрөтү',
    nextStep: 'Кийинки кадам',
    submitting: 'Жөнөтүлүүдө...',
    submit: 'Арызды жөнөтүү',
    termsTitle: 'Маалыматты иштетүү шарттары',
    termsP1: 'Ушуну менен жеке маалыматтарымды Кыргыз Республикасынын мыйзамдарына ылайык иштетүүгө макулдук берем.',
    termsP2: 'Макулдук төмөнкү жеке маалыматтарды иштетүүгө жайылтылат:',
    termsPersonal: 'Жеке адамдын жеке маалыматтары',
    termsContacts: 'Байланыш маалыматы',
    termsDocs: 'Документтер жана маалымдамалар',
    termsP3: 'Маалымат идентификациялоо жана төлөм кызматтарын көрсөтүү үчүн иштетилет.',
    goDashboard: 'Жеке кабинетке өтүү',
    retry: 'Кайра аракет кылуу',
    steps: {
      consent: 'Макулдук',
      personal: 'Маалымат',
      document: 'Документ',
      profile: 'Профиль',
      identification: 'Идентификация',
      confirm: 'Ырастоо',
      face: 'Жүз',
    },
    errors: {
      required: 'Бул талаа милдеттүү',
      minLength: 'Минималдуу узундук: {min} белги',
      notFuture: 'Күн келечекте болбошу керек',
      minAge: 'Минималдуу жаш: {years}',
      pinDigits: 'ПИН 14 сандан турушу керек',
      innDigits: 'ИНН 14 сандан турушу керек',
      activeTitle: 'Арыз мурунтан жөнөтүлгөн',
      activeMessage: 'Сизде идентификация боюнча активдүү арыз бар. Анын каралышын күтүңүз же статусун жеке кабинеттен текшериңиз.',
      emailTitle: 'Email ырасталган эмес',
      emailMessage: 'Арызды жөнөтүү үчүн email даректи ырастаңыз. Почтаны текшерип, каттагы шилтемеге өтүңүз.',
      submitTitle: 'Жөнөтүү катасы',
      submitMessage: 'Арызды жөнөтүүдө ката кетти. Кийинчерээк кайра аракет кылыңыз.',
      storedPhotoFailed: 'Мурда жүктөлгөн сүрөттү тиркөө мүмкүн болгон жок. Байланышты текшерип, кайра аракет кылыңыз.',
    },
    yesWithDetail: 'Ооба ({detail})',
  },
} as const

type Locale = 'ru' | 'en' | 'ky'

function pack<T extends Record<Locale, unknown>>(blocks: T) {
  return blocks
}

const page = pack({
  ru: {
    loading: 'Загрузка данных...',
    completedTitle: 'Ваша верификация завершена!',
    completedMeta: 'Верификация пройдена {date}.',
    statusLabel: 'Статус',
    verifiedData: 'Ваши верифицированные данные:',
    firstName: 'Имя',
    lastName: 'Фамилия',
    middleName: 'Отчество',
    companyName: 'Название компании',
    phone: 'Телефон',
    address: 'Адрес',
    accountSettings: 'Настройки аккаунта',
    becomeLegal: 'Стать юридическим лицом',
    requestType: 'Тип заявки',
    submittedAt: 'Дата подачи',
    reviewedAt: 'Дата рассмотрения',
    submittedData: 'Отправленные данные:',
    personalInfo: 'Персональная информация:',
    birthDate: 'Дата рождения',
    documentNumber: 'Номер документа',
    companyInfo: 'Информация о компании:',
    name: 'Название',
    regNumber: 'Рег. номер',
    legalAddress: 'Юр. адрес',
    specialistComment: 'Комментарий специалиста:',
    reupload: 'Загрузить документы заново',
    continueVerification: 'Продолжить верификацию',
    selectionTitle: 'Верификация аккаунта AlfaBit Payments',
    selectionLead: 'Выберите тип верификации в соответствии с вашими потребностями',
    currentStatus: 'Ваш текущий статус верификации личности',
    limitsTitle: 'Ограничения без верификации личности:',
    limitAccounts: 'Нельзя создавать реальные счета',
    limitPayments: 'Нельзя принимать платежи',
    limitWithdraw: 'Нельзя выводить средства',
    limitApi: 'Ограниченный доступ к API',
    limitSandbox: 'Доступна только тестовая песочница',
    limitsNote: 'Для операций с деньгами необходимо пройти верификацию личности (не путать с верификацией email).',
    benefitsTitle: 'Ваша личность верифицирована! Доступны все возможности:',
    benefitAccounts: 'Создание реальных счетов',
    benefitPayments: 'Прием и отправка платежей',
    benefitWithdraw: 'Вывод средств',
    benefitApi: 'Полный доступ к API',
    benefitLimits: 'Расширенные лимиты',
    upgradeTitle: 'Апгрейд до юридического лица',
    upgradeLead: 'Вы уже верифицированы как физлицо. Расширьте возможности до юридического лица!',
    upgradeUseIndividual: 'Используется ваша верификация физлица',
    upgradeDirector: 'Данные директора заполнены автоматически',
    upgradeTwoSteps: 'Только данные компании (2 шага)',
    upgradeFast: 'Быстрое оформление',
    upgradeConfirmLead: 'Ваши данные физлица будут использованы как данные директора:',
    upgradeConfirmName: 'ФИО',
    upgradeConfirmPassport: 'Паспорт',
    upgradeConfirmPhone: 'Телефон',
    upgradeConfirmAddress: 'Адрес',
    upgradeConfirmCompany: 'Вам нужно будет только добавить данные компании.',
    upgradeConfirmContinue: 'Продолжить?',
    minutes10: '10-15 минут',
    minutes15: '15-20 минут',
    minutes20: '20-30 минут',
    recommended: 'Рекомендуется',
    upgradeAction: 'Апгрейд',
    choose: 'Выбрать',
    individualTitle: 'Физическое лицо',
    individualLead: 'Для частных лиц, которые хотят использовать платежные услуги для личных нужд',
    individualF1: 'Удалённая идентификация и верификация (фото/видео)',
    individualF2: 'Электронные кошельки (для находящихся на территории Кыргызстана или граждан Кыргызстана)',
    individualF3: 'Персональные данные и документ, удостоверяющий личность',
    individualF4: 'Лимиты для личного использования',
    individualF5: 'Базовые платежные функции',
    ipTitle: 'Индивидуальный предприниматель',
    ipLead: 'Для индивидуальных предпринимателей, которые хотят продавать или покупать услуги/товары',
    ipF1: 'идентификация и верификация с предоставлением специального пакета документов в электронном виде и нарочно',
    ipF2: 'включение продаваемых услуг/товаров в перечень Платформы',
    ipF3: 'доступ расчетам за услуги/товары для развития бизнеса',
    ipF4: 'Расширенные лимиты',
    legalTitle: 'Юридическое лицо',
    legalLead: 'Для организаций: проведение расчетов и платежей за услуги и товары',
    legalF1: 'идентификация и верификация с предоставлением специального пакета документов в электронном виде и нарочно',
    legalF2: 'Корпоративные лимиты',
    helpTitle: 'Нужна помощь с выбором?',
    helpText: 'Если вы не уверены, какой тип верификации вам подходит, выберите «Физическое лицо». Вы всегда сможете обновить статус на «Юридическое лицо» позже через службу поддержки.',
    pendingTitle: 'Заявка ожидает рассмотрения',
    reviewTitle: 'Заявка на рассмотрении',
    approvedTitle: 'Верификация успешно завершена',
    rejectedTitle: 'Заявка отклонена',
    moreInfoTitle: 'Требуется дополнительная информация',
    defaultTitle: 'Заявка на верификацию',
    pendingText: 'Ваша заявка поступила в обработку и ожидает рассмотрения специалистом.',
    reviewText: 'Специалист в данный момент проверяет предоставленные документы.',
    approvedText: 'Все документы проверены и одобрены. Ваш аккаунт полностью верифицирован.',
    rejectedText: 'К сожалению, предоставленные документы не прошли проверку.',
    moreInfoText: 'Для завершения верификации требуется предоставить дополнительные документы.',
    defaultText: 'Статус заявки на верификацию.',
    individual: 'Физическое лицо',
    legalEntity: 'Юридическое лицо',
    statusPending: 'На рассмотрении',
    statusChecking: 'Проверяется',
    statusApproved: 'Одобрено',
    statusRejected: 'Отклонено',
    statusMore: 'Уважаемый клиент на вашу электронную почту/ Телеграм/ Ватсапп направлено сообщение о требуемой дополнительной информации и емейл, на который Вам необходимо ее направить. Решение об отказе или одобрении верификации будет принято после изучения запрошенной информации.',
    verified: 'Личность верифицирована',
    notVerified: 'Верификация личности не пройдена',
    verifiedDesc: 'У вас есть полный доступ ко всем функциям платформы',
    notVerifiedDesc: 'Необходимо пройти процедуру верификации личности для доступа к операциям с деньгами',
  },
  en: {
    loading: 'Loading data...',
    completedTitle: 'Your verification is complete!',
    completedMeta: 'Verification completed on {date}.',
    statusLabel: 'Status',
    verifiedData: 'Your verified details:',
    firstName: 'First name',
    lastName: 'Last name',
    middleName: 'Middle name',
    companyName: 'Company name',
    phone: 'Phone',
    address: 'Address',
    accountSettings: 'Account settings',
    becomeLegal: 'Become a legal entity',
    requestType: 'Application type',
    submittedAt: 'Submitted on',
    reviewedAt: 'Reviewed on',
    submittedData: 'Submitted details:',
    personalInfo: 'Personal information:',
    birthDate: 'Date of birth',
    documentNumber: 'Document number',
    companyInfo: 'Company information:',
    name: 'Name',
    regNumber: 'Reg. number',
    legalAddress: 'Legal address',
    specialistComment: 'Specialist’s comment:',
    reupload: 'Upload documents again',
    continueVerification: 'Continue verification',
    selectionTitle: 'AlfaBit Payments account verification',
    selectionLead: 'Choose the verification type that matches your needs',
    currentStatus: 'Your current identity verification status',
    limitsTitle: 'Limits without identity verification:',
    limitAccounts: 'You cannot create real accounts',
    limitPayments: 'You cannot accept payments',
    limitWithdraw: 'You cannot withdraw funds',
    limitApi: 'Limited API access',
    limitSandbox: 'Only the test sandbox is available',
    limitsNote: 'Money operations require identity verification (this is not the same as email verification).',
    benefitsTitle: 'Your identity is verified. Everything is available:',
    benefitAccounts: 'Creating real accounts',
    benefitPayments: 'Sending and receiving payments',
    benefitWithdraw: 'Withdrawing funds',
    benefitApi: 'Full API access',
    benefitLimits: 'Higher limits',
    upgradeTitle: 'Upgrade to a legal entity',
    upgradeLead: 'You are already verified as an individual. Extend your account to a legal entity.',
    upgradeUseIndividual: 'Your individual verification is reused',
    upgradeDirector: 'Director details are filled in automatically',
    upgradeTwoSteps: 'Company details only (2 steps)',
    upgradeFast: 'Faster processing',
    upgradeConfirmLead: 'Your individual details will be used as the director’s details:',
    upgradeConfirmName: 'Full name',
    upgradeConfirmPassport: 'Passport',
    upgradeConfirmPhone: 'Phone',
    upgradeConfirmAddress: 'Address',
    upgradeConfirmCompany: 'You will only need to add the company details.',
    upgradeConfirmContinue: 'Continue?',
    minutes10: '10–15 minutes',
    minutes15: '15–20 minutes',
    minutes20: '20–30 minutes',
    recommended: 'Recommended',
    upgradeAction: 'Upgrade',
    choose: 'Choose',
    individualTitle: 'Individual',
    individualLead: 'For private persons who want payment services for personal use',
    individualF1: 'Remote identification and verification (photo/video)',
    individualF2: 'E-wallets (for people in Kyrgyzstan or citizens of Kyrgyzstan)',
    individualF3: 'Personal details and an identity document',
    individualF4: 'Limits for personal use',
    individualF5: 'Basic payment features',
    ipTitle: 'Sole proprietor',
    ipLead: 'For sole proprietors who want to sell or buy goods and services',
    ipF1: 'identification and verification with a special document package, electronically and in person',
    ipF2: 'adding the goods and services you sell to the Platform list',
    ipF3: 'access to settlements for goods and services to grow the business',
    ipF4: 'Higher limits',
    legalTitle: 'Legal entity',
    legalLead: 'For organizations: settlements and payments for goods and services',
    legalF1: 'identification and verification with a special document package, electronically and in person',
    legalF2: 'Corporate limits',
    helpTitle: 'Need help choosing?',
    helpText: 'If you are not sure which type fits, choose “Individual”. You can later change the status to “Legal entity” through support.',
    pendingTitle: 'Application is waiting for review',
    reviewTitle: 'Application is under review',
    approvedTitle: 'Verification completed successfully',
    rejectedTitle: 'Application rejected',
    moreInfoTitle: 'Additional information required',
    defaultTitle: 'Verification application',
    pendingText: 'Your application has been received and is waiting for a specialist to review it.',
    reviewText: 'A specialist is currently checking the documents you provided.',
    approvedText: 'All documents have been checked and approved. Your account is fully verified.',
    rejectedText: 'Unfortunately, the documents provided did not pass the check.',
    moreInfoText: 'Additional documents are required to finish verification.',
    defaultText: 'Verification application status.',
    individual: 'Individual',
    legalEntity: 'Legal entity',
    statusPending: 'Under review',
    statusChecking: 'Being checked',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    statusMore: 'Dear client, a message about the additional information required and the email address to which you need to send it has been sent to your email, Telegram, or WhatsApp. A decision to reject or approve the verification will be made after the requested information has been reviewed.',
    verified: 'Identity verified',
    notVerified: 'Identity verification not completed',
    verifiedDesc: 'You have full access to every feature of the platform',
    notVerifiedDesc: 'Complete identity verification to use money operations',
  },
  ky: {
    loading: 'Маалымат жүктөлүүдө...',
    completedTitle: 'Верификацияңыз аяктады!',
    completedMeta: 'Верификация {date} өткөрүлгөн.',
    statusLabel: 'Статус',
    verifiedData: 'Верификацияланган маалыматыңыз:',
    firstName: 'Аты',
    lastName: 'Фамилия',
    middleName: 'Атасынын аты',
    companyName: 'Компаниянын аталышы',
    phone: 'Телефон',
    address: 'Дарек',
    accountSettings: 'Эсептин жөндөөлөрү',
    becomeLegal: 'Юридикалык жак болуу',
    requestType: 'Арыздын түрү',
    submittedAt: 'Берилген күнү',
    reviewedAt: 'Каралган күнү',
    submittedData: 'Жөнөтүлгөн маалымат:',
    personalInfo: 'Жеке маалымат:',
    birthDate: 'Туулган күнү',
    documentNumber: 'Документтин номери',
    companyInfo: 'Компания тууралуу маалымат:',
    name: 'Аталышы',
    regNumber: 'Каттоо номери',
    legalAddress: 'Юридикалык дарек',
    specialistComment: 'Адистин комментарийи:',
    reupload: 'Документтерди кайра жүктөө',
    continueVerification: 'Верификацияны улантуу',
    selectionTitle: 'AlfaBit Payments эсебин верификациялоо',
    selectionLead: 'Муктаждыгыңызга жараша верификациянын түрүн тандаңыз',
    currentStatus: 'Инсанды верификациялоонун учурдагы статусу',
    limitsTitle: 'Инсанды верификациясыз чектөөлөр:',
    limitAccounts: 'Чыныгы эсептерди түзүүгө болбойт',
    limitPayments: 'Төлөм кабыл алууга болбойт',
    limitWithdraw: 'Каражат чыгарууга болбойт',
    limitApi: 'API мүмкүнчүлүгү чектелген',
    limitSandbox: 'Тесттик песочница гана жеткиликтүү',
    limitsNote: 'Акча операциялары үчүн инсанды верификациясы керек (email верификациясы менен чаташтырбаңыз).',
    benefitsTitle: 'Инсандыгыңыз верификацияланган. Бардык мүмкүнчүлүктөр ачык:',
    benefitAccounts: 'Чыныгы эсептерди түзүү',
    benefitPayments: 'Төлөмдөрдү кабыл алуу жана жөнөтүү',
    benefitWithdraw: 'Каражат чыгаруу',
    benefitApi: 'API толук мүмкүнчүлүгү',
    benefitLimits: 'Кеңейтилген лимиттер',
    upgradeTitle: 'Юридикалык жакка өтүү',
    upgradeLead: 'Сиз жеке адам катары верификациялангансыз. Мүмкүнчүлүктү юридикалык жакка чейин кеңейтиңиз.',
    upgradeUseIndividual: 'Жеке адамдын верификациясы колдонулат',
    upgradeDirector: 'Директордун маалыматы автоматтык толтурулат',
    upgradeTwoSteps: 'Компаниянын маалыматы гана (2 кадам)',
    upgradeFast: 'Тез тариздөө',
    upgradeConfirmLead: 'Жеке адамдын маалыматыңыз директордун маалыматы катары колдонулат:',
    upgradeConfirmName: 'ФАА',
    upgradeConfirmPassport: 'Паспорт',
    upgradeConfirmPhone: 'Телефон',
    upgradeConfirmAddress: 'Дарек',
    upgradeConfirmCompany: 'Компаниянын маалыматын гана кошуу керек болот.',
    upgradeConfirmContinue: 'Улантасызбы?',
    minutes10: '10–15 мүнөт',
    minutes15: '15–20 мүнөт',
    minutes20: '20–30 мүнөт',
    recommended: 'Сунушталат',
    upgradeAction: 'Өтүү',
    choose: 'Тандоо',
    individualTitle: 'Жеке адам',
    individualLead: 'Төлөм кызматтарын жеке муктаждык үчүн колдонгусу келгендерге',
    individualF1: 'Аралыктан идентификация жана верификация (сүрөт/видео)',
    individualF2: 'Электрондук капчыктар (Кыргызстандын аймагындагылар же Кыргызстандын жарандары үчүн)',
    individualF3: 'Жеке маалымат жана инсандыкты ырастаган документ',
    individualF4: 'Жеке колдонуу үчүн лимиттер',
    individualF5: 'Негизги төлөм функциялары',
    ipTitle: 'Жеке ишкер',
    ipLead: 'Кызмат же товар саткысы же сатып алгысы келген жеке ишкерлер үчүн',
    ipF1: 'атайын документтер топтомун электрондук түрдө жана өзү алып келип идентификациялоо жана верификациялоо',
    ipF2: 'сатылуучу кызматтарды/товарларды Платформанын тизмесине киргизүү',
    ipF3: 'бизнес үчүн кызмат/товар боюнча эсептешүүгө мүмкүнчүлүк',
    ipF4: 'Кеңейтилген лимиттер',
    legalTitle: 'Юридикалык жак',
    legalLead: 'Уюмдар үчүн: кызмат жана товар боюнча эсептешүү жана төлөм',
    legalF1: 'атайын документтер топтомун электрондук түрдө жана өзү алып келип идентификациялоо жана верификациялоо',
    legalF2: 'Корпоративдик лимиттер',
    helpTitle: 'Тандоого жардам керекпи?',
    helpText: 'Кайсы түр сизге туура келерин билбесеңиз, «Жеке адамды» тандаңыз. Кийинчерээк колдоо кызматы аркылуу статусту «Юридикалык жакка» өзгөртсөңүз болот.',
    pendingTitle: 'Арыз кароону күтүүдө',
    reviewTitle: 'Арыз каралууда',
    approvedTitle: 'Верификация ийгиликтүү аяктады',
    rejectedTitle: 'Арыз четке кагылды',
    moreInfoTitle: 'Кошумча маалымат керек',
    defaultTitle: 'Верификация арызы',
    pendingText: 'Арызыңыз иштетүүгө кабыл алынды жана адистин кароосун күтүүдө.',
    reviewText: 'Адис азыр берилген документтерди текшерип жатат.',
    approvedText: 'Бардык документтер текшерилип, жактырылды. Эсебиңиз толук верификацияланды.',
    rejectedText: 'Тилекке каршы, берилген документтер текшерүүдөн өткөн жок.',
    moreInfoText: 'Верификацияны аяктоо үчүн кошумча документтер керек.',
    defaultText: 'Верификация арызынын статусу.',
    individual: 'Жеке адам',
    legalEntity: 'Юридикалык жак',
    statusPending: 'Каралууда',
    statusChecking: 'Текшерилүүдө',
    statusApproved: 'Жактырылды',
    statusRejected: 'Четке кагылды',
    statusMore: 'Урматтуу кардар, сиздин электрондук почтаңызга / Телеграмга / Ватсапка талап кылынган кошумча маалымат жана аны жөнөтүү керек болгон email жөнүндө билдирүү жөнөтүлдү. Верификацияны четке кагуу же жактыруу чечими суралган маалыматты карап чыккандан кийин кабыл алынат.',
    verified: 'Инсандык верификацияланган',
    notVerified: 'Инсанды верификациясы өтүлгөн эмес',
    verifiedDesc: 'Платформанын бардык функцияларына толук мүмкүнчүлүгүңүз бар',
    notVerifiedDesc: 'Акча операциялары үчүн инсанды верификациясынан өтүү керек',
  },
})

const entity = pack({
  ru: {
    lead: 'Идентификация юридического лица',
    noticeCheck: 'Уведомляем, что все представленные данные автоматически будут проверены через государственные информационные системы и другие доступные источники данных.',
    noticeIncomplete: 'При предоставлении неполной или недостоверной информации в исполнении заявки может быть отказано.',
    consentCheck: 'Я подтверждаю согласие на обработку персональных данных юридического лица',
    companyTitle: 'Данные юрлица',
    companyLead: 'Основные характеристики организации',
    clientStatus: 'Статус клиента',
    naming: 'Наименование',
    fullName: 'Полное наименование',
    fullNamePh: 'Полное наименование организации',
    shortName: 'Сокращённое наименование',
    foreignName: 'Наименование на иностранном языке',
    legalForm: 'Организационно-правовая форма',
    legalFormPh: 'ОсОО, АО ...',
    ownership: 'Форма собственности',
    ownershipPrivate: 'Частная',
    ownershipState: 'Государственная',
    ownershipMunicipal: 'Муниципальная',
    ownershipMixed: 'Смешанная',
    ownershipForeign: 'Иностранная',
    stateRegistration: 'Государственная регистрация',
    regCode: 'Номер (код) регистрации',
    regCodePh: 'Код/номер регистрации',
    authorityPh: 'Например: Министерство юстиции КР',
    legalAddress: 'Место регистрации (юридический адрес)',
    legalAddressPh: 'Страна, область, город, район, населённый пункт, улица, дом, корпус, квартира',
    actualAddress: 'Адрес фактического местонахождения и почтовый адрес',
    actualAddressPh: 'Если отличается от юридического адреса',
    codes: 'Идентификационные коды',
    innRequired: 'ИНН',
    innOptional: 'ИНН (если имеется)',
    taxpayerPh: 'Номер налогоплательщика',
    foreignOrgCode: 'Код иностранной организации',
    socialFund: 'Рег. номер Социального фонда КР',
    okpo: 'Код ОКПО',
    orgBic: 'БИК организации',
    orgBicPh: 'Только для коммерческих банков',
    activityKind: 'Вид (характер) деятельности',
    activityKindPh: 'Например: оптовая торговля, IT-услуги',
    contactDetails: 'Контактные данные',
    bankTitle: 'Реквизиты и управление',
    bankLead: 'Банковские реквизиты, органы управления, капитал и присутствие в КР',
    bankDetails: 'Банковские реквизиты',
    bankName: 'Наименование банка',
    bankNamePh: 'Наименование банка',
    account: 'Расчётный счёт',
    accountPh: 'Номер счёта',
    bankBik: 'БИК банка',
    director: 'Руководитель / уполномоченное лицо',
    upgradeBanner: 'Данные подставлены из вашей верификации физлица',
    upgradeEdit: 'При необходимости отредактируйте их.',
    lastNamePh: 'Фамилия',
    firstNamePh: 'Имя',
    position: 'Должность',
    positionPh: 'Директор',
    directorDoc: 'Документ (номер)',
    directorDocPh: 'Серия и номер документа',
    governing: 'Органы управления',
    governingName: 'Наименование органа управления',
    governingNamePh: 'Например: Общее собрание участников, Совет директоров',
    memberName: 'ФИО члена органа управления',
    signRight: 'Право подписи',
    remove: 'Удалить',
    addMember: 'Добавить члена органа управления',
    capitalTitle: 'Полномочия и капитал',
    fundsPh: 'Согласно карточке образцов подписей: устав, приказ, доверенность и т.п.',
    registeredCapital: 'Зарегистрированный уставный капитал',
    paidCapital: 'Оплаченный уставный капитал',
    amountPh: 'Сумма и валюта',
    presenceTitle: 'Присутствие в Кыргызской Республике',
    presenceQuestion: 'Присутствует ли по месту нахождения юрлица его постоянно действующий орган управления или лицо, действующее от имени юрлица без доверенности?',
    presenceDetails: 'Сведения об органе или лице, действующем без доверенности',
    presenceDetailsPh: 'Наименование органа или ФИО лица, адрес',
    branches: 'Филиалы и представительства',
    branchesPh: 'Если имеются: наименование и адрес каждого',
    profileTitle: 'Бенефициар и деловой профиль',
    profileLead: 'Бенефициарный владелец, публичные должностные лица, лицензии и цель отношений',
    beneficialQuestion: 'Бенефициарный владелец юридического лица',
    beneficialStatusRequired: 'Укажите статус бенефициарного владельца',
    pepTitle: 'Публичные должностные лица',
    pepQuestion: 'Есть ли публичное должностное лицо (ПДЛ) в структуре собственности или управления?',
    pepRequired: 'Укажите наличие ПДЛ',
    pepName: 'ФИО и должность ПДЛ',
    pepNamePh: 'ФИО, занимаемая должность и орган',
    licenseTitle: 'Лицензия (при наличии)',
    licenseKind: 'Вид лицензии',
    licenseNumber: 'Номер лицензии',
    licenseValidityPh: 'Например: до 31.12.2027 или бессрочно',
    licenseIssuerPh: 'Лицензирующий орган',
    licenseActivities: 'Перечень видов лицензируемой деятельности',
    licenseActivitiesPh: 'Виды деятельности по лицензии',
    businessProfile: 'Деловой профиль',
    mainActivities: 'Основные виды деятельности',
    mainActivitiesPh: 'Производимые товары, выполняемые работы, предоставляемые услуги',
    mainActivitiesRequired: 'Укажите основные виды деятельности',
    purposePh: 'Например: приём платежей от клиентов, расчёты с контрагентами',
    purposeRequired: 'Укажите цель деловых отношений',
    docsTitle: 'Документы юрлица',
    docsLead: 'Загрузите сканы документов организации',
    companyData: 'Данные юрлица',
    namingShort: 'Наименование',
    formShort: 'Форма',
    regCodeShort: 'Код регистрации',
    activityShort: 'Вид деятельности',
    profileConfirm: 'Бенефициар и деловой профиль',
    pepInStructure: 'ПДЛ в структуре',
    license: 'Лицензия',
    bankAndDirector: 'Реквизиты и руководитель',
    bank: 'Банк',
    directorShort: 'Руководитель',
    governingShort: 'Орган управления',
    documents: 'Документы',
    residentLower: 'резидент',
    nonResidentLower: 'нерезидент',
    termsP1: 'Настоящим я даю согласие на обработку персональных данных организации в соответствии с требованиями законодательства Кыргызской Республики.',
    termsP2: 'Согласие распространяется на обработку следующих данных:',
    termsCompany: 'Данные о компании и руководителе',
    termsBank: 'Банковские реквизиты',
    steps: {
      company: 'Юрлицо',
      management: 'Управление',
      beneficial: 'Бенефициар',
      documents: 'Документы',
    },
    docs: {
      founderDecision: 'Решение учредителя',
      founderDecisionHint: 'Решение о создании юридического лица',
      registration: 'Свидетельство о государственной регистрации',
      registrationHint: 'Свидетельство о государственной регистрации',
      tax: 'Постановка на налоговый учёт',
      taxHint: 'Документ о постановке на налоговый учёт',
      signature: 'Полномочия подписи',
      signatureHint: 'Документы о полномочиях первой и второй подписи',
      anketa: 'Анкета',
      anketaHint: 'Заполненная типовая анкета, если есть',
      charter: 'Устав',
      charterHint: 'Если предусмотрен законодательством КР',
      founding: 'Учредительный договор',
      foundingHint: 'Если предусмотрен законодательством КР',
      amendments: 'Изменения учредительных документов',
      amendmentsHint: 'При перерегистрации',
      license: 'Лицензии',
      licenseHint: 'При наличии лицензируемой деятельности',
      ifLaw: 'Если предусмотрен законодательством КР',
    },
    errors: {
      okpo: 'ОКПО должен содержать от 8 до 10 цифр',
      bik: 'БИК должен содержать от 6 до 9 цифр',
      account: 'Расчётный счёт должен содержать от 16 до 20 цифр',
      email: 'Введите корректный email',
      phone: 'Введите номер в формате +996 XXX XXX XXX',
    },
  },
  en: {
    lead: 'Identification of a legal entity',
    noticeCheck: 'All data you submit will be checked automatically against government information systems and other available sources.',
    noticeIncomplete: 'If the information is incomplete or inaccurate, the application may be declined.',
    consentCheck: 'I consent to the processing of the legal entity’s personal data',
    companyTitle: 'Legal entity details',
    companyLead: 'Main details of the organization',
    clientStatus: 'Client status',
    naming: 'Name',
    fullName: 'Full name',
    fullNamePh: 'Full name of the organization',
    shortName: 'Short name',
    foreignName: 'Name in a foreign language',
    legalForm: 'Legal form',
    legalFormPh: 'LLC, JSC ...',
    ownership: 'Form of ownership',
    ownershipPrivate: 'Private',
    ownershipState: 'State',
    ownershipMunicipal: 'Municipal',
    ownershipMixed: 'Mixed',
    ownershipForeign: 'Foreign',
    stateRegistration: 'State registration',
    regCode: 'Registration number (code)',
    regCodePh: 'Registration code/number',
    authorityPh: 'For example: Ministry of Justice of the KR',
    legalAddress: 'Place of registration (legal address)',
    legalAddressPh: 'Country, region, city, district, locality, street, house, building, apartment',
    actualAddress: 'Actual location and postal address',
    actualAddressPh: 'If it differs from the legal address',
    codes: 'Identification codes',
    innRequired: 'TIN',
    innOptional: 'TIN (if any)',
    taxpayerPh: 'Taxpayer number',
    foreignOrgCode: 'Foreign organization code',
    socialFund: 'Social Fund of the KR registration number',
    okpo: 'OKPO code',
    orgBic: 'Organization BIC',
    orgBicPh: 'Commercial banks only',
    activityKind: 'Type of activity',
    activityKindPh: 'For example: wholesale trade, IT services',
    contactDetails: 'Contact details',
    bankTitle: 'Details and governance',
    bankLead: 'Bank details, governing bodies, capital and presence in the KR',
    bankDetails: 'Bank details',
    bankName: 'Bank name',
    bankNamePh: 'Bank name',
    account: 'Settlement account',
    accountPh: 'Account number',
    bankBik: 'Bank BIC',
    director: 'Director / authorized person',
    upgradeBanner: 'Details were filled from your individual verification',
    upgradeEdit: 'Edit them if needed.',
    lastNamePh: 'Last name',
    firstNamePh: 'First name',
    position: 'Position',
    positionPh: 'Director',
    directorDoc: 'Document (number)',
    directorDocPh: 'Series and document number',
    governing: 'Governing bodies',
    governingName: 'Name of the governing body',
    governingNamePh: 'For example: General meeting of participants, Board of directors',
    memberName: 'Full name of a governing-body member',
    signRight: 'Signing authority',
    remove: 'Remove',
    addMember: 'Add a governing-body member',
    capitalTitle: 'Authority and capital',
    fundsPh: 'According to the signature card: charter, order, power of attorney, and so on.',
    registeredCapital: 'Registered charter capital',
    paidCapital: 'Paid-up charter capital',
    amountPh: 'Amount and currency',
    presenceTitle: 'Presence in the Kyrgyz Republic',
    presenceQuestion: 'Is a permanent governing body, or a person acting for the legal entity without a power of attorney, present at its location?',
    presenceDetails: 'Details of the body or the person acting without a power of attorney',
    presenceDetailsPh: 'Name of the body or the person’s full name, and the address',
    branches: 'Branches and representative offices',
    branchesPh: 'If any: name and address of each',
    profileTitle: 'Beneficial owner and business profile',
    profileLead: 'Beneficial owner, politically exposed persons, licenses and the purpose of the relationship',
    beneficialQuestion: 'Beneficial owner of the legal entity',
    beneficialStatusRequired: 'State the beneficial owner’s status',
    pepTitle: 'Politically exposed persons',
    pepQuestion: 'Is there a politically exposed person (PEP) in the ownership or governance structure?',
    pepRequired: 'State whether there is a PEP',
    pepName: 'PEP full name and position',
    pepNamePh: 'Full name, position and authority',
    licenseTitle: 'License (if any)',
    licenseKind: 'License type',
    licenseNumber: 'License number',
    licenseValidityPh: 'For example: until 31.12.2027 or unlimited',
    licenseIssuerPh: 'Licensing authority',
    licenseActivities: 'List of licensed activities',
    licenseActivitiesPh: 'Activities under the license',
    businessProfile: 'Business profile',
    mainActivities: 'Main activities',
    mainActivitiesPh: 'Goods produced, work performed, services provided',
    mainActivitiesRequired: 'Enter the main activities',
    purposePh: 'For example: accepting customer payments, settlements with counterparties',
    purposeRequired: 'Enter the purpose of the business relationship',
    docsTitle: 'Legal entity documents',
    docsLead: 'Upload scans of the organization’s documents',
    companyData: 'Legal entity details',
    namingShort: 'Name',
    formShort: 'Form',
    regCodeShort: 'Registration code',
    activityShort: 'Type of activity',
    profileConfirm: 'Beneficial owner and business profile',
    pepInStructure: 'PEP in the structure',
    license: 'License',
    bankAndDirector: 'Details and director',
    bank: 'Bank',
    directorShort: 'Director',
    governingShort: 'Governing body',
    documents: 'Documents',
    residentLower: 'resident',
    nonResidentLower: 'non-resident',
    termsP1: 'I hereby consent to the processing of the organization’s personal data in accordance with the laws of the Kyrgyz Republic.',
    termsP2: 'The consent covers processing of the following data:',
    termsCompany: 'Company and director details',
    termsBank: 'Bank details',
    steps: {
      company: 'Entity',
      management: 'Governance',
      beneficial: 'Beneficial owner',
      documents: 'Documents',
    },
    docs: {
      founderDecision: 'Founder’s decision',
      founderDecisionHint: 'Decision to establish the legal entity',
      registration: 'State registration certificate',
      registrationHint: 'Certificate of state registration',
      tax: 'Tax registration',
      taxHint: 'Document of tax registration',
      signature: 'Signing authority',
      signatureHint: 'Documents on the first and second signature authority',
      anketa: 'Questionnaire',
      anketaHint: 'A completed standard questionnaire, if you have one',
      charter: 'Charter',
      charterHint: 'If required by the laws of the KR',
      founding: 'Founding agreement',
      foundingHint: 'If required by the laws of the KR',
      amendments: 'Amendments to founding documents',
      amendmentsHint: 'In case of re-registration',
      license: 'Licenses',
      licenseHint: 'If the activity is licensed',
      ifLaw: 'If required by the laws of the KR',
    },
    errors: {
      okpo: 'OKPO must contain 8 to 10 digits',
      bik: 'BIC must contain 6 to 9 digits',
      account: 'The settlement account must contain 16 to 20 digits',
      email: 'Enter a valid email',
      phone: 'Enter a number as +996 XXX XXX XXX',
    },
  },
  ky: {
    lead: 'Юридикалык жакты идентификациялоо',
    noticeCheck: 'Берилген бардык маалымат мамлекеттик маалымат системалары жана башка жеткиликтүү булактар аркылуу автоматтык түрдө текшерилерин билдиребиз.',
    noticeIncomplete: 'Маалымат толук эмес же так эмес болсо, арызды аткаруудан баш тартылышы мүмкүн.',
    consentCheck: 'Юридикалык жактын жеке маалыматтарын иштетүүгө макулдук берем',
    companyTitle: 'Юридикалык жактын маалыматы',
    companyLead: 'Уюмдун негизги мүнөздөмөлөрү',
    clientStatus: 'Кардардын статусу',
    naming: 'Аталышы',
    fullName: 'Толук аталышы',
    fullNamePh: 'Уюмдун толук аталышы',
    shortName: 'Кыскартылган аталышы',
    foreignName: 'Чет тилиндеги аталышы',
    legalForm: 'Уюштуруу-укуктук формасы',
    legalFormPh: 'ЖЧК, АК ...',
    ownership: 'Менчик формасы',
    ownershipPrivate: 'Жеке',
    ownershipState: 'Мамлекеттик',
    ownershipMunicipal: 'Муниципалдык',
    ownershipMixed: 'Аралаш',
    ownershipForeign: 'Чет өлкөлүк',
    stateRegistration: 'Мамлекеттик каттоо',
    regCode: 'Каттоо номери (коду)',
    regCodePh: 'Каттоо коду/номери',
    authorityPh: 'Мисалы: КР Юстиция министрлиги',
    legalAddress: 'Каттоо жери (юридикалык дарек)',
    legalAddressPh: 'Өлкө, облус, шаар, район, калктуу пункт, көчө, үй, корпус, батир',
    actualAddress: 'Иш жүзүндөгү жайгашкан жери жана почта дареги',
    actualAddressPh: 'Юридикалык даректен айырмаланса',
    codes: 'Идентификациялык коддор',
    innRequired: 'ИНН',
    innOptional: 'ИНН (бар болсо)',
    taxpayerPh: 'Салык төлөөчүнүн номери',
    foreignOrgCode: 'Чет өлкөлүк уюмдун коду',
    socialFund: 'КР Социалдык фондунун каттоо номери',
    okpo: 'ОКПО коду',
    orgBic: 'Уюмдун БИК',
    orgBicPh: 'Коммерциялык банктар үчүн гана',
    activityKind: 'Иштин түрү (мүнөзү)',
    activityKindPh: 'Мисалы: дүң соода, IT-кызматтар',
    contactDetails: 'Байланыш маалыматы',
    bankTitle: 'Реквизиттер жана башкаруу',
    bankLead: 'Банк реквизиттери, башкаруу органдары, капитал жана КРде катышуу',
    bankDetails: 'Банк реквизиттери',
    bankName: 'Банктын аталышы',
    bankNamePh: 'Банктын аталышы',
    account: 'Эсептешүү эсеби',
    accountPh: 'Эсептин номери',
    bankBik: 'Банктын БИК',
    director: 'Жетекчи / ыйгарым укуктуу адам',
    upgradeBanner: 'Маалымат жеке адамдын верификацияңыздан коюлду',
    upgradeEdit: 'Керек болсо түзөтүңүз.',
    lastNamePh: 'Фамилия',
    firstNamePh: 'Аты',
    position: 'Кызматы',
    positionPh: 'Директор',
    directorDoc: 'Документ (номер)',
    directorDocPh: 'Документтин сериясы жана номери',
    governing: 'Башкаруу органдары',
    governingName: 'Башкаруу органынын аталышы',
    governingNamePh: 'Мисалы: Катышуучулардын жалпы чогулушу, Директорлор кеңеши',
    memberName: 'Башкаруу органынын мүчөсүнүн ФАА',
    signRight: 'Кол коюу укугу',
    remove: 'Өчүрүү',
    addMember: 'Башкаруу органынын мүчөсүн кошуу',
    capitalTitle: 'Ыйгарым укук жана капитал',
    fundsPh: 'Кол тамгалардын үлгү картасына ылайык: устав, буйрук, ишеним кат ж.б.',
    registeredCapital: 'Катталган уставдык капитал',
    paidCapital: 'Төлөнгөн уставдык капитал',
    amountPh: 'Сумма жана валюта',
    presenceTitle: 'Кыргыз Республикасында катышуу',
    presenceQuestion: 'Юридикалык жактын турган жеринде анын туруктуу башкаруу органы же ишеним катсыз анын атынан иштеген адам барбы?',
    presenceDetails: 'Ишеним катсыз иштеген орган же адам жөнүндө маалымат',
    presenceDetailsPh: 'Органдын аталышы же адамдын ФАА, дареги',
    branches: 'Филиалдар жана өкүлчүлүктөр',
    branchesPh: 'Бар болсо: ар биринин аталышы жана дареги',
    profileTitle: 'Бенефициар жана ишкердик профили',
    profileLead: 'Бенефициардык ээ, коомдук кызмат адамдары, лицензиялар жана мамиленин максаты',
    beneficialQuestion: 'Юридикалык жактын бенефициардык ээси',
    beneficialStatusRequired: 'Бенефициардык ээнин статусун көрсөтүңүз',
    pepTitle: 'Коомдук кызмат адамдары',
    pepQuestion: 'Менчик же башкаруу структурасында коомдук кызмат адамы (ПДЛ) барбы?',
    pepRequired: 'ПДЛ бар экенин көрсөтүңүз',
    pepName: 'ПДЛдин ФАА жана кызматы',
    pepNamePh: 'ФАА, ээлеген кызматы жана орган',
    licenseTitle: 'Лицензия (бар болсо)',
    licenseKind: 'Лицензиянын түрү',
    licenseNumber: 'Лицензиянын номери',
    licenseValidityPh: 'Мисалы: 31.12.2027 чейин же мөөнөтсүз',
    licenseIssuerPh: 'Лицензия берүүчү орган',
    licenseActivities: 'Лицензияланган иштин түрлөрүнүн тизмеси',
    licenseActivitiesPh: 'Лицензия боюнча иштин түрлөрү',
    businessProfile: 'Ишкердик профили',
    mainActivities: 'Негизги иштин түрлөрү',
    mainActivitiesPh: 'Чыгарылган товарлар, аткарылган жумуштар, көрсөтүлгөн кызматтар',
    mainActivitiesRequired: 'Негизги иштин түрлөрүн көрсөтүңүз',
    purposePh: 'Мисалы: кардарлардан төлөм кабыл алуу, контрагенттер менен эсептешүү',
    purposeRequired: 'Ишкердик мамилелердин максатын көрсөтүңүз',
    docsTitle: 'Юридикалык жактын документтери',
    docsLead: 'Уюмдун документтеринин сканын жүктөңүз',
    companyData: 'Юридикалык жактын маалыматы',
    namingShort: 'Аталышы',
    formShort: 'Формасы',
    regCodeShort: 'Каттоо коду',
    activityShort: 'Иштин түрү',
    profileConfirm: 'Бенефициар жана ишкердик профили',
    pepInStructure: 'Структурадагы ПДЛ',
    license: 'Лицензия',
    bankAndDirector: 'Реквизиттер жана жетекчи',
    bank: 'Банк',
    directorShort: 'Жетекчи',
    governingShort: 'Башкаруу органы',
    documents: 'Документтер',
    residentLower: 'резидент',
    nonResidentLower: 'резидент эмес',
    termsP1: 'Ушуну менен уюмдун жеке маалыматтарын Кыргыз Республикасынын мыйзамдарына ылайык иштетүүгө макулдук берем.',
    termsP2: 'Макулдук төмөнкү маалыматтарды иштетүүгө жайылтылат:',
    termsCompany: 'Компания жана жетекчи жөнүндө маалымат',
    termsBank: 'Банк реквизиттери',
    steps: {
      company: 'Юр. жак',
      management: 'Башкаруу',
      beneficial: 'Бенефициар',
      documents: 'Документтер',
    },
    docs: {
      founderDecision: 'Уюштуруучунун чечими',
      founderDecisionHint: 'Юридикалык жакты түзүү жөнүндө чечим',
      registration: 'Мамлекеттик каттоо күбөлүгү',
      registrationHint: 'Мамлекеттик каттоо күбөлүгү',
      tax: 'Салык эсебине коюу',
      taxHint: 'Салык эсебине коюу документи',
      signature: 'Кол коюу ыйгарым укугу',
      signatureHint: 'Биринчи жана экинчи колдун ыйгарым укугу жөнүндө документтер',
      anketa: 'Анкета',
      anketaHint: 'Толтурулган типтүү анкета, бар болсо',
      charter: 'Устав',
      charterHint: 'КР мыйзамында каралган болсо',
      founding: 'Уюштуруу келишими',
      foundingHint: 'КР мыйзамында каралган болсо',
      amendments: 'Уюштуруу документтеринин өзгөрүүлөрү',
      amendmentsHint: 'Кайра каттоодо',
      license: 'Лицензиялар',
      licenseHint: 'Лицензияланган иш болсо',
      ifLaw: 'КР мыйзамында каралган болсо',
    },
    errors: {
      okpo: 'ОКПО 8ден 10го чейин сандан турушу керек',
      bik: 'БИК 6дан 9га чейин сандан турушу керек',
      account: 'Эсептешүү эсеби 16дан 20га чейин сандан турушу керек',
      email: 'Туура email киргизиңиз',
      phone: 'Номерду +996 XXX XXX XXX форматында киргизиңиз',
    },
  },
})

const address = pack({
  ru: {
    fields: {
      country: 'Страна',
      region: 'Область',
      city: 'Город',
      district: 'Район',
      settlement: 'Населённый пункт',
      street: 'Улица',
      house: 'Дом',
      building: 'Корпус',
      apartment: 'Квартира',
    },
    placeholders: {
      country: 'Кыргызстан',
      region: 'Чуйская',
      city: 'Бишкек',
      district: 'Ленинский',
      settlement: 'Если не город',
      street: 'Киевская',
      house: '1',
      building: '',
      apartment: '',
    },
    errors: {
      mixedScript: 'Не смешивайте кириллицу и латиницу',
      cyrillicOnly: 'Только кириллица: адрес заполняется на одном языке',
      latinOnly: 'Только латиница: адрес заполняется на одном языке',
      russianOnly: 'Только на русском языке',
      englishOnly: 'Только на английском языке',
      countryRequired: 'Укажите страну',
      cityRequired: 'Укажите город или населённый пункт',
      streetRequired: 'Укажите улицу',
      houseRequired: 'Укажите дом',
      tooLong: 'Адрес слишком длинный',
    },
  },
  en: {
    fields: {
      country: 'Country',
      region: 'Region',
      city: 'City',
      district: 'District',
      settlement: 'Locality',
      street: 'Street',
      house: 'House',
      building: 'Building',
      apartment: 'Apartment',
    },
    placeholders: {
      country: 'Kyrgyzstan',
      region: 'Chuy',
      city: 'Bishkek',
      district: 'Leninsky',
      settlement: 'If not a city',
      street: 'Kievskaya',
      house: '1',
      building: '',
      apartment: '',
    },
    errors: {
      mixedScript: 'Do not mix Cyrillic and Latin letters',
      cyrillicOnly: 'Cyrillic only: the address must be in one language',
      latinOnly: 'Latin only: the address must be in one language',
      russianOnly: 'Russian only',
      englishOnly: 'English only',
      countryRequired: 'Enter the country',
      cityRequired: 'Enter a city or locality',
      streetRequired: 'Enter the street',
      houseRequired: 'Enter the house number',
      tooLong: 'The address is too long',
    },
  },
  ky: {
    fields: {
      country: 'Өлкө',
      region: 'Облус',
      city: 'Шаар',
      district: 'Район',
      settlement: 'Калктуу пункт',
      street: 'Көчө',
      house: 'Үй',
      building: 'Корпус',
      apartment: 'Батир',
    },
    placeholders: {
      country: 'Кыргызстан',
      region: 'Чүй',
      city: 'Бишкек',
      district: 'Ленин',
      settlement: 'Шаар болбосо',
      street: 'Киевская',
      house: '1',
      building: '',
      apartment: '',
    },
    errors: {
      mixedScript: 'Кириллица менен латиницаны аралаштырбаңыз',
      cyrillicOnly: 'Кириллица гана: дарек бир тилде толтурулат',
      latinOnly: 'Латиница гана: дарек бир тилде толтурулат',
      russianOnly: 'Орус тилинде гана',
      englishOnly: 'Англис тилинде гана',
      countryRequired: 'Өлкөнү көрсөтүңүз',
      cityRequired: 'Шаарды же калктуу пунктту көрсөтүңүз',
      streetRequired: 'Көчөнү көрсөтүңүз',
      houseRequired: 'Үйдү көрсөтүңүз',
      tooLong: 'Дарек өтө узун',
    },
  },
})

const capture = pack({
  ru: {
    stepsAria: 'Шаги проверки',
    photograph: 'Сфотографировать',
    takeSelfie: 'Сфотографироваться',
    attachPhoto: 'Прикрепить фото',
    pngJpg: 'PNG, JPG',
    attachPdf: 'Прикрепить PDF',
    photo: 'Фото',
    retake: 'Переснять',
    anotherPhoto: 'Другое фото',
    remove: 'Удалить',
    preview: '{label}: предпросмотр',
    shooting: 'Съёмка: {label}',
    backHint: 'Положите карту так, чтобы три нижние строки с символами «<» оказались внутри рамки. Без бликов.',
    frontHint: 'Совместите края карты с рамкой. Фото, ФИО и номер должны читаться.',
    startingCamera: 'Включаем камеру…',
    cancel: 'Отмена',
    shutter: 'Снять',
    switchCamera: 'Переключить камеру',
    openPhoneCamera: 'Открыть камеру телефона',
    fileTooBig: 'Файл больше 10 МБ. Сожмите изображение или выберите другой файл.',
    badDocumentFile: 'Нужен файл PDF, PNG, JPG или снимок с камеры телефона.',
    badPhotoFile: 'Нужно фото в формате JPG или PNG.',
    cameraDenied: 'Доступ к камере запрещён. Разрешите камеру в настройках браузера или откройте камеру телефона.',
    cameraUnavailableDocument: 'Камера недоступна в этом браузере. Откройте камеру телефона или прикрепите файл.',
    cameraUnavailablePhoto: 'Камера недоступна в этом браузере. Откройте камеру телефона или прикрепите фото.',
    captureFailed: 'Не удалось сохранить снимок. Попробуйте ещё раз.',
    selfieGuide: 'Лицо в овале, паспорт в рамке. Без бликов — фото и данные должны читаться.',
    face: 'Лицо',
    passport: 'Паспорт',
  },
  en: {
    stepsAria: 'Verification steps',
    photograph: 'Take a photo',
    takeSelfie: 'Take a selfie',
    attachPhoto: 'Attach a photo',
    pngJpg: 'PNG, JPG',
    attachPdf: 'Attach a PDF',
    photo: 'Photo',
    retake: 'Retake',
    anotherPhoto: 'Another photo',
    remove: 'Remove',
    preview: '{label}: preview',
    shooting: 'Capture: {label}',
    backHint: 'Place the card so the three bottom lines with «<» symbols are inside the frame. No glare.',
    frontHint: 'Align the card edges with the frame. The photo, name and number must be readable.',
    startingCamera: 'Starting the camera…',
    cancel: 'Cancel',
    shutter: 'Capture',
    switchCamera: 'Switch camera',
    openPhoneCamera: 'Open the phone camera',
    fileTooBig: 'The file is larger than 10 MB. Compress the image or choose another file.',
    badDocumentFile: 'A PDF, PNG, JPG or a photo from the phone camera is required.',
    badPhotoFile: 'A JPG or PNG photo is required.',
    cameraDenied: 'Camera access is blocked. Allow the camera in the browser settings or open the phone camera.',
    cameraUnavailableDocument: 'The camera is unavailable in this browser. Open the phone camera or attach a file.',
    cameraUnavailablePhoto: 'The camera is unavailable in this browser. Open the phone camera or attach a photo.',
    captureFailed: 'Could not save the photo. Please try again.',
    selfieGuide: 'Face in the oval, passport in the frame. No glare — the photo and the data must be readable.',
    face: 'Face',
    passport: 'Passport',
  },
  ky: {
    stepsAria: 'Текшерүү кадамдары',
    photograph: 'Сүрөткө тартуу',
    takeSelfie: 'Селфи тартуу',
    attachPhoto: 'Сүрөт тиркөө',
    pngJpg: 'PNG, JPG',
    attachPdf: 'PDF тиркөө',
    photo: 'Сүрөт',
    retake: 'Кайра тартуу',
    anotherPhoto: 'Башка сүрөт',
    remove: 'Өчүрүү',
    preview: '{label}: алдын ала көрүү',
    shooting: 'Тартуу: {label}',
    backHint: 'Картаны «<» белгилери бар үч төмөнкү сап алкактын ичинде калгандай коюңуз. Жаркырабасын.',
    frontHint: 'Картанын четтерин алкак менен тууралаңыз. Сүрөт, аты-жөнү жана номери окулушу керек.',
    startingCamera: 'Камера күйгүзүлүүдө…',
    cancel: 'Жокко чыгаруу',
    shutter: 'Тартуу',
    switchCamera: 'Камераны алмаштыруу',
    openPhoneCamera: 'Телефондун камерасын ачуу',
    fileTooBig: 'Файл 10 МБдан чоң. Сүрөттү кичирейтиңиз же башка файл тандаңыз.',
    badDocumentFile: 'PDF, PNG, JPG же телефондун камерасынан тартылган сүрөт керек.',
    badPhotoFile: 'JPG же PNG сүрөт керек.',
    cameraDenied: 'Камерага уруксат жок. Браузердин жөндөөлөрүнөн камерага уруксат бериңиз же телефондун камерасын ачыңыз.',
    cameraUnavailableDocument: 'Бул браузерде камера жеткиликсиз. Телефондун камерасын ачыңыз же файл тиркеңиз.',
    cameraUnavailablePhoto: 'Бул браузерде камера жеткиликсиз. Телефондун камерасын ачыңыз же сүрөт тиркеңиз.',
    captureFailed: 'Сүрөт сакталган жок. Кайра аракет кылыңыз.',
    selfieGuide: 'Жүз сүйрүдө, паспорт алкакта. Жаркырабасын — сүрөт жана маалымат окулушу керек.',
    face: 'Жүз',
    passport: 'Паспорт',
  },
})

export const kycUi = {
  ru: {
    kyc: {
      form: form.ru,
      page: page.ru,
      entity: entity.ru,
      capture: capture.ru,
    },
    address: address.ru,
  },
  en: {
    kyc: {
      form: form.en,
      page: page.en,
      entity: entity.en,
      capture: capture.en,
    },
    address: address.en,
  },
  ky: {
    kyc: {
      form: form.ky,
      page: page.ky,
      entity: entity.ky,
      capture: capture.ky,
    },
    address: address.ky,
  },
}
